import { createRoute, useNavigate } from '@tanstack/react-router'
import { useContext } from 'react'
import rootRoute from './rootRoute'
import type { Event } from '@/lib/types'
import type { components } from '@/lib/client'
import { errorToast, toast } from '@/components/ui'
import { LoginContext, loggedInRouteLoader } from '@/lib/auth'
import EventForm from '@/components/EventForm'
import { EventStatus } from '@/lib/constants'
import { $client } from '@/lib/fetch'

type CreateEvent = components['schemas']['CreateEvent']

function NewEvent() {
  const ctx = useContext(LoginContext)!
  const isAdmin = ctx.user?.admin ?? false
  const navigate = useNavigate()

  const onCreate = async (data: CreateEvent) => {
    const { error, data: created } = await $client.POST('/api/events/', {
      body: { event: data },
    })

    if (error) {
      if (error.detail === 'validation failed') {
        const named: Record<string, string> = {}
        error.errors?.forEach((e) => {
          const [, name] = (e.location || '').split('body.event.')
          if (e.message) named[name || ''] = e.message
        })
        return named
      }
      errorToast("Échec de la création de l'événement", error)
      return
    }

    toast({ color: 'success', title: 'Événement créé avec succès !' })
    navigate({ to: '/events/$id', params: { id: String(created.event.id) } })
  }

  const defaultEvent: Event = {
    title: '',
    description: '',
    external_id: '',
    id: 0,
    location: { address: '', latitude: 0, longitude: 0 },
    source: 'manual',
    start_date: new Date().toISOString(),
    status: EventStatus.NotVerified,
    type: { description: '', emoji: '', image_uri: '', type: 'Cours' },
  }

  return (
    <EventForm
      label="Rassemblez la communauté"
      event={defaultEvent}
      onSubmit={onCreate}
      isAdmin={isAdmin}
    />
  )
}

export const newEventRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/new-event',
  loader: loggedInRouteLoader as any,
}).lazy(() => import('./NewEvent.lazy').then((m) => m.Route))

export default NewEvent
